var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-grid__wrap" }, [
    _c(
      "div",
      {
        staticClass:
          "product-grid ProductList hidden-pocket product-visible-desk",
      },
      _vm._l(_vm.products, function (product, idx) {
        return _c("v-product", { key: idx, attrs: { product: product } })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "container", staticClass: "swiper-container product-hidden-desk" },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.products, function (product, idx) {
            return _c(
              "div",
              { key: idx, staticClass: "swiper-slide" },
              [_c("v-product", { attrs: { product: product } })],
              1
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }